'use client';
import { useApi } from '@prismo-io/core';
import useSWR from 'swr';
import useDebounceValue from '../../../helpers/use-debounce';
import { fetchExperienceTypes } from './fetch-experience-types';

type Props = {
  isOpen: boolean;
  term: string | null;
};

export const useExperienceTypesAutocomplete = (props: Props) => {
  const { isOpen, term } = props;

  const termDebounced = useDebounceValue(term, 400);

  const { client } = useApi();

  return useSWR(
    () => (isOpen ? ['experience-types-autocomplete', termDebounced] : null),
    ([_, term]) => fetchExperienceTypes(client, term)
  );
};
